import { MdOutlineChat, MdOutlineSupportAgent, MdStar } from 'react-icons/md';
import { FaCar } from 'react-icons/fa';
import { IconType } from 'react-icons';
import {isIde, isMobileApp} from '../../../Utils/misc/envNameUtils.ts';

export const getModeIcon = (mode: string, customModes: Record<string, any> = {}): IconType => {
    // Check if it's a custom mode first
    const customMode = customModes[mode];
    if (customMode) {
        return MdStar;
    }

    // Default built-in modes
    switch (mode) {
        case 'chat':
            return MdOutlineChat;
        case 'agent':
            return MdOutlineSupportAgent;
        case 'fsd':
            return FaCar;
        default:
            return MdOutlineChat;
    }
};

export const getModeText = (mode: string, environment: string, customModes: Record<string, any> = {}): string => {
    // Check if it's a custom mode first
    const customMode = customModes[mode];
    if (customMode) {
        return mode; // The mode key IS the display name now
    }
    const isIdeEnvironment = isIde(environment);

    if (isIdeEnvironment) {
        // IDE environment - show "No Tools", "Normal", "Complex"
        switch (mode) {
            case 'chat':
                return 'No Tools';
            case 'agent':
                return 'Normal';
            case 'fsd':
                return 'Complex';

            default:
                return mode.charAt(0).toUpperCase() + mode.slice(1);
        }
    } else {
        switch (mode) {
            case 'agent':
                return 'Normal';
            default:
                return mode.charAt(0).toUpperCase() + mode.slice(1);
        }
    }
};

export const getTooltipContent = (mode: string, environment: string, customModes: Record<string, any> = {}): string => {
    if (isMobileApp(environment)) return "";

    // Check if it's a custom mode first
    const customMode = customModes[mode];
    if (customMode) {
        return customMode.description || "Custom mode";
    }

    const isIdeEnvironment = isIde(environment);

    if (isIdeEnvironment) {
        switch (mode) {
            case 'chat':
                return 'Normal Q&A - no tools';
            case 'agent':
                return 'Small Scoped Changes';
            case 'fsd':
                return 'Large, more complex changes';
            default:
                return '';
        }
    } else {
        switch (mode) {
            case 'agent':
                return 'Normal queries and assistance';
            default:
                return '';
        }
    }
};

export const getAvailableModes = (environment: string): string[] => {
    const isIdeEnvironment = isIde(environment);

    if (isIdeEnvironment) {
        // return ['chat', 'agent', 'fsd'];
        return ['chat', 'agent'];
    } else {
        return ['agent'];  // Fallback for other environments
    }
};
